var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vuw-close-button",class:_vm.backgroundColor,attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":function($event){return _vm.$emit('close')}}},[_c('i',{staticClass:"fa-light fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }